'use strict';

module Patersons {

    export interface MarketDepthScope extends ng.IScope {
        marketDepthInformation: any;     
        securityCode: string;   
        events: MarketDepthCtrl;
        isLoading: boolean;
        
    }

    export class MarketDepthCtrl extends PortfolioBaseCtrl {
        scope: Patersons.MarketDepthScope;
        portfolioService: Patersons.PortfolioService;
        static $inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', 'portfolioService','navigationService'];

        constructor($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, portfolioService, navigationService) {
            super($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService);
            this.scope = $scope;
            this.scope.events = this;
            this.portfolioService = portfolioService;
        }
        
        load() {
            if (this.scope.securityCode == null || this.scope.securityCode == "") {
                return;
            }

            this.scope.isLoading = true;

            this.portfolioService.getOrderDepthData(this.scope.securityCode)
                .then((result) => {
                    this.scope.marketDepthInformation = result;                                                                                   
                }).finally(() => {
                    this.scope.isLoading = false; 
                });
        }  
    }
}
